const HeaderActions = () => {
  // Empty for the time being
  return <div className="flex items-center"></div>
}

export default HeaderActions
